
import AudioTracks from "./audioTracks";
import MainContentUpload from "./mainContent";
import SubtitleTracks from "./subtitlesTracks";
import TrailerUpload from "./trailer";

const MovieUploader = ({ selectedContent, updateContent }) => {

    const formattedMovie = {
        ...selectedContent,
        contentId: selectedContent.key,
        contentType: "movie",
    }

    const formattedTrailer = {
        ...selectedContent,
        contentId: selectedContent.key,
        contentType: "movies_trailer",
    }

    const handleContentUpdate = (content) => {
        updateContent(content)
    }

    return (
        <>
            <div style={{ display: "flex", gap: 40 }}>
                <MainContentUpload selectedContent={formattedMovie} updateContentChild={handleContentUpdate} />
                <TrailerUpload selectedContent={formattedTrailer} updateTrailer={handleContentUpdate} />
            </div>
            <div style={{ display: "flex", gap: 40 }}>
                <AudioTracks selectedContent={formattedMovie} />
                <SubtitleTracks selectedContent={formattedMovie} />
            </div>

        </>
    )
}

export default MovieUploader;
